/** PLN 149 net/month with 100 included minutes per paid period (doc 59 §1). */
export const OFFER_PLN149_100_V1 = {
    version: 'pln149_100_v1',
    includedSecondsPerPeriod: 100 * 60,
    currencies: ['PLN'],
};
export const SUBSCRIPTION_OFFERS = [OFFER_PLN149_100_V1];
/** The offer a wallet is enrolled in, or null (prepaid without an allowance). */
export function findOffer(version) {
    if (!version)
        return null;
    return SUBSCRIPTION_OFFERS.find((o) => o.version === version) ?? null;
}
/** Seconds a wallet's offer grants per paid period (0 without an offer). */
export function includedSecondsPerPeriod(version) {
    return findOffer(version)?.includedSecondsPerPeriod ?? 0;
}
/**
 * Deterministic allowance id for ONE entitlement period: the subscription, its
 * item and the period start. Several events or invoices for the same period map
 * to the same id, so the grant can be claimed exactly once (doc 59 N02, A03/A04).
 */
export function allowanceIdFor(subscriptionId, subscriptionItemId, periodStartUnix) {
    return `${subscriptionId}_${subscriptionItemId}_${periodStartUnix}`.replace(/[^A-Za-z0-9_-]/g, '');
}
//# sourceMappingURL=offer.js.map